module.exports = {"brand":"RedmerU"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand.json
// module id = 7ny3
// module chunks = 1